import React from 'react';

/**
 * Shared "Show Definition" UI used in game modals.
 * Expects the same dictionaryapi.dev response shape used elsewhere in the app.
 */
const DefinitionSection = ({
  word,
  showDefinition,
  definition,
  isLoadingDefinition,
  toggleDefinition,
}) => {
  if (!word) return null;

  return (
    <>
      <button className="definition-button" onClick={toggleDefinition}>
        {showDefinition ? 'Hide Definition' : 'Show Definition'}
      </button>

      {showDefinition && (
        <div className={`definition-container ${showDefinition ? 'showing' : 'hiding'}`}>
          {isLoadingDefinition ? (
            <div className="definition-loading">Loading definition...</div>
          ) : definition ? (
            <div className="definition-content">
              {definition[0]?.meanings?.map((meaning, index) => (
                <div key={index} className="definition-meaning">
                  <p className="definition-part">{meaning.partOfSpeech}</p>
                  <ul className="definition-list">
                    {meaning.definitions.map((def, i) => (
                      <li key={i}>{def.definition}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ) : (
            <div className="definition-error">
              We don't have the definition on this app, but you can{' '}
              <a
                href={`https://www.google.com/search?q=${word}+meaning`}
                target="_blank"
                rel="noopener noreferrer"
                className="definition-search-link"
              >
                search for it here
              </a>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default DefinitionSection;

